import debounce from 'lodash.debounce'

export default {
  provide () {
    return { tableFilterable: this.tableFilterable }
  },
  data: () => ({
    tableFilterable: {
      rowCount: 0,
      filteredRowCount: null,
      filters: {},
      searchTerm: ''
    }
  }),
  computed: {
    totalDisplayed () {
      const totalCount = this.$options.dataSource.allData.length
      if (!this.tableFilterable.rowCount && !totalCount) return 0
      return this.tableFilterable.filteredRowCount ?? totalCount
    },
    filtersAsArray: {
      get: ({ tableFilterable }) => [tableFilterable.filters, tableFilterable.searchTerm],
      set ([filters, searchTerm] = [{}, '']) {
        this.tableFilterable.filters = filters
        this.tableFilterable.searchTerm = searchTerm
      }
    }
  },
  watch: {
    'tableFilterable.rowCount' () {
      this.updateRowCount()
    },
    'tableFilterable.filters': {
      handler () {
        this.updateRowCount()
      },
      deep: true
    },
    'tableFilterable.searchTerm': {
      handler: debounce(function () {
        this.updateRowCount()
      }, 300)
    }
  },
  methods: {
    async updateRowCount () {
      await nextTick()

      // Optional Chaining prevents console errors, as this function triggered before gridOptions.api
      // is initialized by the asynchronous ag-grid `grid-ready` callback event.
      this.tableFilterable.filteredRowCount = this.$refs.dataTable?.gridOptions?.api?.getDisplayedRowCount()
    }
  }
}
